export default __webpack_public_path__ + "static/media/hero-4.7c29d6b4.jpg";